import React, { useState, useEffect, useRef } from 'react';
import api from '../../Services/Api';
import styles from './MotivationalQuote.module.css';

const DailyQuoteWidget = ({ showRefresh = false, compact = false, center = false }) => {
  const [quote, setQuote] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showFull, setShowFull] = useState(false);
  
  // Create a reference to the widget container
  const widgetRef = useRef(null);

  // --- Logic: Fetch Quote ---
  useEffect(() => {
    const cachedQuote = localStorage.getItem('dailyQuote');
    const cachedDate = localStorage.getItem('dailyQuoteDate');
    const today = new Date().toDateString();
    
    if (cachedQuote && cachedDate === today) {
      setQuote(JSON.parse(cachedQuote));
    } else {
      fetchDailyQuote();
    }
  }, []);

  const fetchDailyQuote = async () => {
    try {
      setLoading(true);
      const response = await api.get('daily_quote/');
      const newQuote = response.data;
      console.log('Fetched new daily quote:', newQuote);
      setQuote(newQuote);
      localStorage.setItem('dailyQuote', JSON.stringify(newQuote));
      localStorage.setItem('dailyQuoteDate', new Date().toDateString());
    } catch (error) {
      console.error('Error fetching daily quote:', error);
      setQuote({ text: "Progress, not perfection.", author: "Anonymous" });
    } finally {
      setLoading(false);
    }
  };

  // --- Logic: Close on Click Outside ---
  useEffect(() => {
    const handleClickOutside = (event) => {
      // If the widget is expanded and the user clicks outside the widget container
      if (showFull && widgetRef.current && !widgetRef.current.contains(event.target)) {
        setShowFull(false);
      }
    };

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    
    // Clean up the listener on unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showFull]); // Only re-run if showFull state changes

  if (loading && !quote) {
    return (
      <div className={`${styles.quoteWidget} ${styles.loading} ${center ? styles.centerWidget : ''}`}>
        <div className={styles.spinnerSmall}></div>
        <span>Loading inspiration...</span>
      </div>
    );
  }

  if (!quote) return null;

  const widgetClass = `
    ${styles.quoteWidget} 
    ${center ? styles.centerWidget : ''} 
    ${showFull ? styles.expanded : ''}
  `;

  return (
    <div className={widgetClass} ref={widgetRef}>
      <div className={styles.quoteHeader}>
        <div className={styles.quoteIconSmall}>💭</div>
        <h4 className={styles.quoteTitle}>Quote of the Day</h4>
      </div>
      
      <blockquote className={styles.quoteTextWidget}>
        "{quote.message}"
      </blockquote>
      
      <div className={styles.quoteAuthorWidget}>
        — {quote.author}
      </div>

      {compact && (
        <button 
          className={styles.expandButton}
          onClick={() => setShowFull(!showFull)}
          aria-label="Toggle Quote Details"
        >
          {showFull ? '▲' : '▼'}
        </button>
      )}

      {/* Show controls only when expanded */}
      {showFull && showRefresh && (
        <div className={styles.controls}>
          <button 
            className={styles.refreshButtonSmall}
            onClick={(e) => {
              e.stopPropagation(); // Stop event from triggering the click-outside
              fetchDailyQuote();
            }}
          >
            🔄 New Quote
          </button>
        </div>
      )}
    </div>
  );
};

export default DailyQuoteWidget;